import React, {useEffect, useState} from "react";
// import FaceBook from "../../../assets/images/icon/Facebook.svg";
// import Twitter from "../../../assets/images/icon/twitter.svg";
// import Instagram from "../../../assets/images/icon/instagram.svg";
import {ReactComponent as GoogleIcon} from "../../../assets/images/icon/googleIcon.svg";
import {Button} from "antd";
import {useNavigate} from "react-router-dom";

const Menu: React.FC = () => {
    const [menu, setMenu] = useState(false);
    const navigate = useNavigate();
    const handleClick = () => {
        setMenu((prevMenu) => !prevMenu);
    };

    function handleLinkClick(event: any) {
        event.preventDefault();
        setMenu(false);
        const targetId = event.target.getAttribute("href");
        const targetSection = document.querySelector(targetId);

        if (targetSection) {
            targetSection.scrollIntoView({behavior: "smooth"});
        }
    }

    function ClickSpecialOffer() {
        navigate("/special-offer");
    }

    useEffect(() => {
        if (menu) {
            document.body.classList.add("menu-open");
        } else {
            document.body.classList.remove("menu-open");
        }
    }, [menu]);

    return (
        <div className="menuWrapper">
            {/* <div className="socialIcon">
				<ul>
					<div className="headerUpdate">For more updates:</div>
					<li>
						<a href="#">
							<img src={FaceBook} alt="facebook" />
						</a>
					</li>
					<li>
						<a href="#">
							<img src={Twitter} alt="twitter" />
						</a>
					</li>
					<li>
						<a href="#">
							<img src={Instagram} alt="instagram" />
						</a>
					</li>
				</ul>
			</div> */}
            <div className={`${menu ? "open headernav" : "headernav"}`}>
                <ul>
                    <li>
                        <a href="#aboutus" id="about" onClick={handleLinkClick}>
                            About Us
                        </a>
                    </li>
                    <li>
                        <a href="#featurepage" id="feature" onClick={handleLinkClick}>
                            Feature
                        </a>
                    </li>
                    <li>
                        <a href="#kapturely" id="whykapturely" onClick={handleLinkClick}>
                            Why Kapturely
                        </a>
                    </li>
                    {/* <li><a href="#blog" id="blogLink" onClick={handleLinkClick}>Blogs</a></li> */}
                    <li>
                        <a href="#contactus" id="contact" onClick={handleLinkClick}>
                            Contact Us
                        </a>
                    </li>
                </ul>
            </div>
            <div className="headerBtn">
                <Button className="commanBtn" onClick={ClickSpecialOffer}>
                    <span className="arrowIcon">
                        <GoogleIcon />
                    </span>
                    <span className="beforeIcon"></span>

                    <span>Sign Up For Free</span>
                </Button>

                <div className={`${menu ? "active hamburger" : "hamburger"}`}>
                    <Button className="toggle-button" onClick={handleClick}>
                        <span className="line"></span>
                        <span className="line"></span>
                        <span className="line"></span>
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default Menu;
